import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGridMonitor = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "grid-monitor" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: 1.5,
			y: 1.5,
			width: 21,
			height: 21,
			rx: 1,
			ry: 1
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 7.5,
			y1: 4.5,
			x2: 7.5,
			y2: 19.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 12,
			y1: 4.5,
			x2: 12,
			y2: 19.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 16.5,
			y1: 4.5,
			x2: 16.5,
			y2: 19.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 19.5,
			y1: 7.5,
			x2: 4.5,
			y2: 7.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 19.5,
			y1: 12,
			x2: 4.5,
			y2: 12
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 19.5,
			y1: 16.5,
			x2: 4.5,
			y2: 16.5
		})
	]
});
export default SvgGridMonitor;
